import * as React from "react";
import styled, { css } from "styled-components";
import { lighten } from "polished";

import { breakpoint } from "src/library/utils/styled-media-queries/index";
import Grid from "src/library/components/Hedron";
import { InListContext } from "src/core/shared/components/HeaderContext/InListContext";
import { InOrderContext } from "src/core/shared/components/HeaderContext/InOrderContext";
import { ContextHeight } from "src/context/SideBarContext/utils";

import { MenuContextType } from "../../hooks/menu/useMenu";

interface IHeaderContextProps {
  context: MenuContextType;
  isMobileMenu?: boolean;
}

const HeaderContext: React.ReactFCWithChildren<IHeaderContextProps> = ({ context, isMobileMenu }) => {
  const showOnMobile = [ "ORDER_PRODUCT_SELECTION", "LIST_PRODUCT_SELECTION" ].includes(context.type);

  return (
    <HeaderItemsWrapper className={`header-context ${showOnMobile && isMobileMenu ? "mobile-visible" : ""}`}>
      {context.type === "ORDER_PRODUCT_SELECTION" && <InOrderContext />}

      {context.type === "LIST_PRODUCT_SELECTION" && <InListContext />}
    </HeaderItemsWrapper>
  );
};

export default HeaderContext;

const HeaderItemsWrapper = styled(Grid.Bounds)`
${({ theme }) => css`
  width: 100%;
  height: 100%;
  background: ${theme.overrides?.contextMenu?.background ? theme.overrides.contextMenu.background : lighten(0.05, theme.colors.primaryLight)};
  justify-content: flex-end;
  display: none;

  &.mobile-visible {
    display: flex;

    .in-list-wrapper {
      justify-content: space-between;

      .context-item {
        margin-left: ${theme.spacing.margins.sm};
      }
    }
  }

  ${breakpoint("md", theme)} {
    min-height: ${ContextHeight}px;
    height: ${ContextHeight}px;
    
    &.mobile-visible {
      display: none;
    }
  }
  
  .icon-wrapper {
    padding: 0 ${theme.spacing.padding.xl} 0 ${theme.spacing.padding.md};
    display: flex;
    align-items: center;
    position: relative;
    padding-left: ${theme.spacing.padding.md};

    &:before {
      content: "";
      width: 2px;
      height: 100%;
      background: ${theme.colors.lightestGrey};
      position: absolute;
      top: 0;
      left: 0;
    }

    .unread {
      position: relative;

      &:after {
        content: "";
        width: 5px;
        height: 5px;
        border-radius: 50%;
        top: 0;
        right: 0;
        position: absolute;
        background: ${theme.colors.provisionalOrder};
      }
    }
  }
`}
`;
